<template>
  <div
    id="app"
    class="d-flex flex-column"
    :class="{ 'min-vh-100': !isMatchView }"
  >
    <Header v-if="!isMatchView" />
    <transition name="slide" mode="out-in">
      <router-view />
    </transition>
    <Footer v-if="!isMatchView" />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  computed: {
    isMatchView() {
      return this.$route.name === "match";
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        const on = to.name === "match";
        document.body.classList.toggle("match-view-body", on);
        document.documentElement.classList.toggle("match-view-body", on);
      },
    },
  },
  beforeDestroy() {
    document.body.classList.remove("match-view-body");
    document.documentElement.classList.remove("match-view-body");
  },
};
</script>
